import React from "react";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  Navigate,
} from "react-router-dom";
import "./App.css";
import { AppProvider } from "./AppContext";
import requireAuth from "./components/requireAuth";
import requireAdmin from "./components/requireAdmin";
import requireReports from "./components/requireReports";
import CheckAuth from "./components/CheckAuth";
// UI Components
import Auth from "./layouts/Auth";
import Admin from "./layouts/Admin";
import User from "./layouts/User";

function App() {
  return (
    <AppProvider>
      <Router>
        <Routes>
          <Route path="/*" element={requireAuth(User)} />
          <Route path="/admin/*" element={requireAdmin(Admin)} />
          <Route path="/reports/*" element={requireReports(Admin)} />
          <Route path="/login" element={CheckAuth(Auth)} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </Router>
    </AppProvider>
  );
}

export default App;
